import {useNavigation} from '@react-navigation/core';
import {Button, Layout, Text} from '@ui-kitten/components';
import moment from 'moment';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {DRAWER_ROUTES} from '../../../../navigation/constants';
import {px} from '../../../../utils';
import {ProgressBar} from '../../../components';

const SubscriptionCard = () => {
  const navigation = useNavigation();
  const kids = useSelector((state) => state.general.kids);
  const {transactionDetails, packageStartDate, packageExpDate} =
    kids?.[0] || {};

  const handleRenew = () => {
    navigation.navigate(DRAWER_ROUTES.subscription.path);
  };

  if (!transactionDetails) {
    return (
      <Layout style={styles.container}>
        <Text style={styles.trailHeading}>{'You have no subscription'}</Text>
        <Text style={styles.text}>
          {'Get a subscription to join the class.'}
        </Text>
        <Button
          onPress={() => navigation.navigate(DRAWER_ROUTES.subscription.path)}>
          {'Buy Subscription'}
        </Button>
      </Layout>
    );
  }

  if (packageExpDate) {
    const remainingDays = moment(packageExpDate).diff(moment(), 'day');
    const month = moment(packageExpDate).format('MMMM');

    const isExpired = remainingDays < 0;

    if (isExpired) {
      return (
        <Layout style={styles.container}>
          <Text style={[styles.trailHeading]}>
            {'Your subscription has expired'}
          </Text>
          <ProgressBar percent={0} />
          <Text style={styles.text}>{'Please renew to resume the class.'}</Text>
          <Button onPress={handleRenew}>{'Renew'}</Button>
        </Layout>
      );
    }

    var allDays = moment(packageExpDate).diff(moment(packageStartDate), 'day');
    if (allDays > 0) {
      allDays = allDays + 1;
    }
    const pastDays = allDays - remainingDays;
    var percent = (pastDays * 100) / allDays;

    return (
      <Layout style={styles.container}>
        <Text style={styles.trailHeading}>
          {`Your subscription of ${month} month will expire on `}
          {moment(packageExpDate).format('MMM D, YYYY')}
        </Text>
        <ProgressBar percent={percent} />
        <Text style={styles.text}>
          {remainingDays +
            ' days left before expiry date. Please renew to avoid class interruption.'}
        </Text>
        <Button onPress={handleRenew}>{'Renew'}</Button>
      </Layout>
    );
  }
};

const styles = StyleSheet.create({
  container: {
    marginBottom: px(20),
    marginHorizontal: 31,
    paddingHorizontal: px(17),
    paddingTop: px(22),
    paddingBottom: px(20),
    borderColor: '#3A86FF',
    borderWidth: 2,
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,

    elevation: 8,
  },
  titleContainer: {
    paddingHorizontal: 0,
    marginTop: 0,
  },
  trailHeading: {
    fontSize: px(16),
    fontWeight: '600',
    textAlign: 'center',
    color: '#ED3722',
  },
  text: {
    marginVertical: px(16),
    fontSize: px(16),
    textAlign: 'center',
  },
});

export default SubscriptionCard;
